import React from "react";

export default function MainBody() {
  return (
    <div className="main-body">
      {/* Logo section */}
      <div style={{ zIndex: 1, padding: "20px" }}>
        <div className="logo-section">
          <img
            src={require("./assets/hbc-logo.png")}
            alt="Harong-Bikolnon-logo"
            className="logo-image"
          />
        </div>
        <div className="body-section">
          <h1 className="body-title">Homebound: The Musical</h1>
          <p className="body-body">
            Set against the backdrop of the Christmas season, Homebound The
            Musical tells a heartfelt narrative of a young individual’s journey
            toward self-discovery, the rebuilding of self-worth, and the
            rediscovery of the true value of family. Through its universal
            themes of hope, resilience, and belonging, the play aims to
            cultivate emotional intelligence, strengthen moral values, and
            celebrate Filipino familial traditions.
          </p>
        </div>{" "}
        {/* Set against the backdrop of the Christmas season, Homebound The Musical
      tells a heartfelt narrative of a young individual’s journey toward
      self-discovery, the rebuilding of self-worth, and the rediscovery of the
      true value of family. Through its universal themes of hope, resilience,
      and belonging, the play aims to cultivate emotional intelligence,
      strengthen moral values, and celebrate Filipino familial traditions. */}
      </div>
    </div>
  );
}
